<template lang="html">
  <div class="page-password-reset">
    <PasswordForm
      v-model="user"
      :btnConfirmLoading="btnConfirmLoading"
      @submit="reset"/>
  </div>
</template>

<script>
import {resetPassword} from '@/lib/users'

import PasswordForm from '@/components/forms/PasswordForm'

export default {
  name: 'reset-password',

  components: {
    PasswordForm
  },

  data() {
    return {
      user: {},
      btnConfirmLoading: false
    }
  },

  props: {
    token: String
  },

  computed: {
    email() {
      return this.$route.query.email
    }
  },

  methods: {
    reset() {
      this.btnConfirmLoading = true

      let user = {
        email: this.email,
        password: this.user.password,
        password_reset_token: this.token
      }

      resetPassword(user)
        .then(() => {
          this.btnConfirmLoading = false
          this.$router.push({name: 'login', query: {passwordReset: 'true'}})
        })
        .catch(() => {
          alert('There was an error resetting your password.')
          this.btnConfirmLoading = false
        })
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.page-password-reset
  display: flex
  flex-direction: row
  width: 100%
  align-items: center
  height: calc(100vh - #{$header-height})

  @include themify($themes)
    background: themed('color-tertiary')

  h1
    text-align: center
</style>
